(() => {
  let dialog, trigger, previousOverflow;
  const node = (tag, className, text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (typeof text === 'string') el.textContent = text;
    return el;
  };
  window.mtmOpenProduct = (item, section, url) => {
    if (!dialog) {
      dialog = node('dialog', 'mtm-product-dialog');
      dialog.setAttribute('aria-labelledby', 'mtm-product-dialog-title');
      document.body.append(dialog);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow;
        if (trigger?.isConnected) trigger.focus({preventScroll:true});
      });
    }
    if (dialog.open) return;
    trigger = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    const labels = section.dataset;
    const close = node('button', 'mtm-product-close', '×');
    close.type = 'button'; close.setAttribute('aria-label', labels.mtmHighlightClose);
    close.addEventListener('click', () => dialog.close());
    const hero = node('div', 'mtm-product-hero');
    const heading = node('div', 'mtm-product-heading');
    heading.append(node('p', 'mtm-product-code', 'MTM / ' + (item.code || 'OEM · ODM')));
    const title = node('h2', '', item.title); title.id = 'mtm-product-dialog-title';
    heading.append(title);
    if (item.subtitle) heading.append(node('p', 'mtm-product-subtitle', item.subtitle));
    const visual = node('div', 'mtm-product-visual');
    const image = node('img'); image.src = url; image.alt = item.title; image.width = 1402; image.height = 1122;
    visual.append(image); hero.append(visual);
    const body = node('div', 'mtm-product-body');
    body.append(heading);
    const definitions = [
      {label:labels.mtmHighlightFeatures, values:item.bullets, key:'features'},
      {label:labels.mtmHighlightOptional, values:item.optionalBullets, key:'options'}
    ].filter(e => Array.isArray(e.values) && e.values.some(v => typeof v === 'string' && v.trim()));
    definitions.forEach(entry => {
      const panel = node('section', 'mtm-product-panel mtm-product-' + entry.key);
      const label = node('h3', '', entry.label);
      const list = node('ul', 'mtm-product-features');
      entry.values.filter(v => typeof v === 'string' && v.trim()).forEach(text => list.append(node('li','',text)));
      panel.append(label,list); body.append(panel);
    });
    const footer = node('div','mtm-product-footer');
    const contact = node('a','mtm-product-contact',labels.mtmHighlightCta); contact.href = '/pages/contact';
    footer.append(node('span','mtm-product-footer-brand','MTM · YOUR INNOVATION PROVIDER'),contact);
    body.append(footer);
    dialog.replaceChildren(close,hero,body);
    dialog.showModal(); document.documentElement.style.overflow = 'hidden';
  };
})();
